import React,{useState} from "react";
import './log.css';
import {Link} from 'react-router-dom';

function Login() {
    const [acessLog, setAcessLog] = useState('');
    const [acessPass, setAcessPass] = useState('');
    const [valido, setValido] = useState(false);
    function VerifyLog(event){
        setAcessLog(event.target.value);
    }
    function VerifyPass(event){
        setAcessPass(event.target.value);
    }
    function verifyAll(event){

        if(acessLog === admLogin && acessPass === admPass){
            setValido(true)
        }else{
            setValido(false);
        }
    }
    const admLogin = 'AdegaTratoria';
    const admPass = 'Adega@Tratoria267';
  return (
      <div className="Login-container">
          <h1>Login Adega</h1>
          <label htmlfor="login" className="login-input"></label>
          <input type="user" name="user" placeholder="Your name" />
          <label htmlfor="login" className="login-input"></label>
          <input type="user" name="user" placeholder="Login ADM" onChange={VerifyLog}/>
          <label htmlfor="Senha" className="login-input"></label>
          <input type="password" name="login-senha" placeholder="senha" onChange={VerifyPass}/>
          <button  className="button_login" onClick={() => verifyAll()}>
            Verificar
           </button>
           {valido ? 
           
            <Link className="button_login" to='/controller'> 
                Next Page 
            </Link > :
            null   
            }
            
        </div>
  );
}

export default Login